import React from "react";
import styled from "styled-components";
import { Link } from "./Link";

type Props = {
  community?: boolean;
  status?: boolean;
  docs?: boolean;
  path?: string;
  className?: string;
  children?: any;
};

const LinkElem = styled(Link)`
  text-decoration: none;
`;

export const DOLink: React.FC<Props> = ({ community, status, docs, path, children, ...delegated }: Props) => {
  let url = "https://www.digitalocean.com";
  let content = "DigitalOcean";

  if (community) {
    url += "/community";
    content = "community";
  } else if (docs) {
    url += "/docs";
    content = "knowledgebase";
  } else if (status) {
    url = "https://status.digitalocean.com";
    content = "status.digitalocean.com";
  }

  if (path) {
    url += (path.indexOf("/") !== 0 ? "/" : "") + path;
  }

  return (
    <LinkElem to={url} {...delegated}>
      {children ? children : content}
    </LinkElem>
  );
};
